// GraphQL query constants
export const EP_PREFIX = `end_of_trial_day`;
export const HAMS_PRODUCT_KEY = 'confluence.ondemand';
export const OFFERING_KEY = '7547cfd6-a804-4e42-8bed-e656d49ea09e';

// Statsig constants
export const STATSIG_END_OF_TRIAL_EXPERIMENT = 'confluence_end_of_trial_modal_switcheroo';
export const STATSIG_END_OF_TRIAL_GATE = 'confluence_end_of_trial_modal_gate_switcheroo';

// Statsig cohorts
export const statsigCohorts = {
	NON_ENROLLED: 'not-enrolled',
	TREATMENT: 'treatment',
	CONTROL: 'control',
};

// Analytics constants
export const analytics = {
	MODAL_ACTION_SUBJECT_ID: 'end-of-trial-payment-modals',
	HOOK_ACTION_SUBJECT_ID: 'end-of-trial-payment-modals-loading-hooks',
	SOURCE: 'endOfTrialModal',
};
